<template>
  <el-alert
    v-if="visible"
    :closable="false"
    type="success"
    effect="dark"
    show-icon
  >
    <template #title>
      <div class="payments-review-alert">
        <div>Your payments are under review.</div>
        <div>{{ detailsText }}. It may take up to 2 business days</div>
      </div>
    </template>
  </el-alert>
</template>
<script lang="ts">
import { defineComponent, computed } from 'vue'
import { useUserStore } from '@/store/modules/user'

export default defineComponent({
  name: 'MessageAlertPayPal',
  setup: () => {
    const userStore = useUserStore()
    const payments = computed(() => {
      return userStore.paymentsUnderReview.filter(
        (payment) => payment.new_payment
      )
    })
    const visible = computed(() => payments.value.length > 0)
    const detailsText = computed(() => {
      return payments.value
        .map((payment) => `${payment.payment_system}: ${payment.amount}$`)
        .join(', ')
    })

    return { visible, detailsText }
  }
})
</script>
